import { render, staticRenderFns } from "./trade-maps-input.vue?vue&type=template&id=36e548ca&"
import script from "./trade-maps-input.vue?vue&type=script&lang=js&"
export * from "./trade-maps-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports